import React, { useState } from "react";
import { Link } from "react-router-dom";
import AddtoWishlist from "./AddtoWishlist";
import PriceHtml from "./PriceHtml";

import { getPriceSymbole } from "../Helper";

const ProductCardSearch = React.forwardRef(({ product: e }, ref) => {
  const symbol = getPriceSymbole();
  const GalleryImages = JSON.parse(e.images);

  const [hoverimg, setHoverimg] = useState(true);
  const ToggleImg = () => {
    setHoverimg(!hoverimg);
  }; 

  const productContent = (    
      <div className="productlist">
        <div className="imgbox">
          {e.discount > 0 && (
            <span className="onsale">Sale!</span>
          )}

          {e.current_stock < 1 && (
            <div className="out-of-stock-custom">Sold Out</div>
          )}
          <AddtoWishlist p_id={e.id} />
          <Link to={`/product/${e.slug}`} target="_blank">
          {GalleryImages.length>0?(
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${hoverimg ? GalleryImages[0] : GalleryImages[1]}`}
              alt={e.name}
              title={e.name} className="defaultimg" onMouseEnter={ToggleImg} onMouseOut={ToggleImg} loading="lazy" width="500px" height="699px" 
            />
          ):''}
          

          </Link>
        </div>
        <div className="producttitle">
          <h2>
            <Link to={`/product/${e.slug}`}>
              {e.name.length > 40 ? e.name.substring(0, 40) + "..." : e.name}
            </Link>
          </h2>
          {e.unit_price && (
            <PriceHtml
              pdata={{
                discount: e.discount,
                discount_type: e.discount_type,
                price: e.unit_price,
                symbol: symbol,
                divclass: "price-box",
                shipping_time: e.shipping_time,
                pagefrom: "productlist",
              }}
            />
          )}
        </div>
      </div>
    
  );

  const content = ref ? (
    <div className="col-md-3 col-sm-6 col-xs-12 mb-40" ref={ref}>
      {productContent}
    </div>
  ) : (
    <div className="col-md-3 col-sm-6 col-xs-12 mb-40" >{productContent}</div>
  );
  return content;
});

export default ProductCardSearch;
